import React from 'react';
import styles from './PollActions.css?module';

const PollActions = ({children}) => (
  <div className={styles.PollActions}>{children}</div>
);

export default PollActions;
